// extracted by mini-css-extract-plugin
export default {"navigationBar":"_1OPYF","title":"_1ez3s","placeHolderShimmer":"_3WkKR","filter":"q5PD1","subTitle":"_3396h","text":"_3olJz"};